import { formatMoney } from "./formatMoney"

export const formatMoneyInCents = (value: number) => {
  return formatMoney(value / 100)
}
